import React, { FC } from 'react';
import { TNewsListingItem } from '../../types/newsListing.types';
import NewsCard from '../newsCard';

const NewsCardList: FC<{ items: TNewsListingItem[] }> = (props) => {
  if (props.items.length === 0) {
    return null;
  }
  return (
    <ul className="news-listing__card-list">
      {props.items.map((item) => {
        return (
          <li className="news-listing__card" key={`${item?.id}`}>
            <NewsCard {...item} />
          </li>
        );
      })}
    </ul>
  );
};

export default NewsCardList;
